import { render, staticRenderFns } from "./goodList.vue?vue&type=template&id=5367c864&scoped=true&"
import script from "./goodList.vue?vue&type=script&lang=js&"
export * from "./goodList.vue?vue&type=script&lang=js&"
import style0 from "./goodList.vue?vue&type=style&index=0&id=5367c864&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5367c864",
  null
  
)

export default component.exports